import { FAST_API_URL, postOptions } from "../../../../../api";
import { FixAnswer, StreamFix } from "./model";

export interface AnswerResult {
    answered: string;
    /** «Разрешить сократить соседнюю» — новая заявка того же текста с разрешением; иначе null. */
    fix: StreamFix | null;
}

export class AnswerError extends Error {
    constructor(
        message: string,
        public status: number,
    ) {
        super(message);
    }
}

/**
 * Ответ на вопрос заявки правки (п.50г; вопрос правки времени — «Оставить как в эфире»): translate-python
 * `POST /stream_editor/v1/fixes/{id}/answer` → site_server `POST /realtime/streams/{m}/fixes/{id}/answer`.
 * Отвечает тот, кто правил (или админ): решает site_server. Отказ — `AnswerError` с причиной словами.
 */
export const answerFix = async (mediaId: string, fixId: string, answer: FixAnswer): Promise<AnswerResult> => {
    const response = await fetch(
        `${FAST_API_URL}/fixes/${encodeURIComponent(fixId)}/answer?media=${encodeURIComponent(mediaId)}`,
        { ...postOptions, body: JSON.stringify({ answer }) },
    );
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
        const detail = body?.detail;
        throw new AnswerError(
            (typeof detail === "string" ? detail : detail?.message || detail?.code || "") ||
                `сервер ответил ${response.status}`,
            response.status,
        );
    }
    return { answered: String(body?.answered || answer), fix: body?.fix || null };
};
